import * as React from 'react';
import { Question, QuestionFormResponse } from '../types/questionnaire.types';
import {
  getAnsweredCount,
  getProgressPercentage,
  isFormValid,
} from '../utils/questionValidation';
import { formatResponses } from '../utils/responseFormatter';
import { useQuestionNavigation } from './useQuestionNavigation';
import { useQuestionResponses } from './useQuestionResponses';
import { useQuestionTimer } from './useQuestionTimer';

interface UseQuestionFormProps {
  questions: Question[];
  // onSubmit: (responses: QuestionFormResponse[]) => Promise<void>;
  onSubmit: (responses: QuestionFormResponse[]) => void | Promise<void>;
  timeLimit: number;
}

export const useQuestionForm = ({
  questions,
  onSubmit,
  timeLimit,
}: UseQuestionFormProps) => {
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);

  const responseHandlers = useQuestionResponses();
  const { responses } = responseHandlers;

  // Retorna a Promise sem capturar o erro aqui —
  // o ConfirmationDialog é responsável pelo try/catch e feedback visual.
  // Só fecha o dialog em caso de sucesso (o pai controla via prop `open`).
  const handleFinalSubmit = React.useCallback(async (): Promise<void> => {
    const formattedResponses = formatResponses(questions, responses);

    // Deixa a Promise rejeitar naturalmente para o ConfirmationDialog capturar
    await onSubmit(formattedResponses);

    // Só executa se onSubmit resolveu com sucesso
    setShowConfirmDialog(false);
  }, [questions, responses, onSubmit]);

  // Versão silenciosa usada pelo timer (sem feedback de dialog)
  const handleTimerExpiredSubmit =
    React.useCallback(async (): Promise<void> => {
      try {
        const formattedResponses = formatResponses(questions, responses);
        await onSubmit(formattedResponses);
      } catch (error) {
        console.error('Erro ao submeter após expiração do tempo:', error);
        // Aqui você pode adicionar um toast/snackbar global se quiser
      } finally {
        setShowConfirmDialog(false);
      }
    }, [questions, responses, onSubmit]);

  const navigation = useQuestionNavigation({ questions, responses });

  const timer = useQuestionTimer({
    timeLimit,
    onTimeExpired: handleTimerExpiredSubmit,
  });

  const formValidation = {
    isValid: isFormValid(questions, responses),
    answeredCount: getAnsweredCount(questions, responses),
    progressPercentage: getProgressPercentage(questions, responses),
  };

  const handleSubmitClick = React.useCallback(() => {
    if (formValidation.isValid) {
      setShowConfirmDialog(true);
    }
  }, [formValidation.isValid]);

  return {
    ...responseHandlers,
    ...navigation,
    ...timer,
    ...formValidation,
    showConfirmDialog,
    setShowConfirmDialog,
    handleSubmitClick,
    handleFinalSubmit,
  };
};

// import * as React from 'react';
// import { Question, QuestionFormResponse } from '../types/questionnaire.types';
// import {
//   getAnsweredCount,
//   getProgressPercentage,
//   isFormValid,
// } from '../utils/questionValidation';
// import { formatResponses } from '../utils/responseFormatter';
// import { useQuestionNavigation } from './useQuestionNavigation';
// import { useQuestionResponses } from './useQuestionResponses';
// import { useQuestionTimer } from './useQuestionTimer';

// interface UseQuestionFormProps {
//   questions: Question[];
//   onSubmit: (responses: QuestionFormResponse[]) => void;
//   timeLimit: number;
// }

// export const useQuestionForm = ({
//   questions,
//   onSubmit,
//   timeLimit,
// }: UseQuestionFormProps) => {
//   const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);

//   const responseHandlers = useQuestionResponses();
//   const { responses } = responseHandlers;

//   const handleFinalSubmit = React.useCallback(async () => {
//     setShowConfirmDialog(false);

//     const formattedResponses = formatResponses(questions, responses);
//     await onSubmit(formattedResponses);
//   }, [questions, responses, onSubmit]);

//   const navigation = useQuestionNavigation({ questions, responses });
//   const timer = useQuestionTimer({
//     timeLimit,
//     onTimeExpired: handleFinalSubmit,
//   });

//   const formValidation = {
//     isValid: isFormValid(questions, responses),
//     answeredCount: getAnsweredCount(questions, responses),
//     progressPercentage: getProgressPercentage(questions, responses),
//   };

//   const handleSubmitClick = React.useCallback(() => {
//     if (formValidation.isValid) {
//       setShowConfirmDialog(true);
//     }
//   }, [formValidation.isValid]);

//   return {
//     ...responseHandlers,
//     ...navigation,
//     ...timer,
//     ...formValidation,
//     showConfirmDialog,
//     setShowConfirmDialog,
//     handleSubmitClick,
//     handleFinalSubmit,
//   };
// };
